import React from "react";
import { PublicPage, LegalSection } from "../components/PublicPage";

export default function Privacy() {
  return (
    <PublicPage title="Privacy Policy" testid="privacy-page">
      <p className="text-sm text-spotter-maroon/70">Last updated: June 2026. This policy is a plain-language starting point and is not legal advice — please have it reviewed by a qualified attorney before relying on it.</p>

      <LegalSection heading="What we collect">
        <p>To run your account, Spotter collects your <b>username, display name, legal name, email address, date of birth</b>, and the <b>profile customization data</b> you choose to add — such as your background choice, profile music, bio, photos, and top spots.</p>
      </LegalSection>

      <LegalSection heading="How we use it">
        <p>We use this information only to operate Spotter: to show your profile, deliver messages and notifications, keep the community safe, and (for members aged 16–17) to enable parent/guardian oversight.</p>
      </LegalSection>

      <LegalSection heading="We never sell your data">
        <p>Spotter <b>does not sell your personal data to third parties</b>, ever. We do not run third-party ad networks on your personal information.</p>
      </LegalSection>

      <LegalSection heading="Minors">
        <p>Members aged 16–17 sign up with a parent or guardian who approves their account and reviews their friend requests and customization changes.</p>
      </LegalSection>

      <LegalSection heading="Your choices">
        <p>You can edit or delete your profile information at any time from Settings, and you can request account deletion. Some data may be retained where required for legal or safety reasons.</p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>Questions about your privacy? Reach us through the <a href="/report" className="underline font-semibold">Report page</a>.</p>
      </LegalSection>
    </PublicPage>
  );
}
